import { makeSearchInput } from 'components/common/SearchInput';
import { CommonTranslationKeys } from 'intl/keys';
import { EntityLabel } from 'components/common/SearchInput/types';
import { WithDataGridApi } from 'components/common/withDataGridApi';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withProcessesData } from 'components/common/withProcessesData';
import { CompanyDataGridActions } from 'components/company/CompanyDataGrid/CompanyDataGridActions';
import { CompanyTable } from 'components/company/Table';
import { MemoTableAnchor } from 'components/tableAnchor';
import { useAppNavigation } from 'contexts/navigation';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { ReactElement } from 'react';
import { useProjectId } from 'store/project';
import { useCompanies } from 'store/company';
import { useInitialSearchEffect } from '../../../hooks/search/useInitialSearch';
import { useSearchUpdate } from '../../../hooks/search/useSearchUpdate';

const CompanySearchInput = makeSearchInput(EntityLabel.company);

const header = {
  id: 'create-company-button',
  textId: CommonTranslationKeys.buttonCreateCompany,
  dataQaId: 'create-company-button',
};

function Companies(): ReactElement {
  const { loading, setSearchPhrase } = useCompanies();
  const projectId = useProjectId();
  const { canCreateCompany } = usePermissions();

  useSearchUpdate(EntityLabel.company, setSearchPhrase);
  useInitialSearchEffect(projectId, EntityLabel.company, setSearchPhrase);

  const { goToCreateCompany } = useAppNavigation();

  return (
    <WithDataGridApi>
    <MemoTableAnchor
      canCreate={canCreateCompany}
      creationAction={goToCreateCompany}
      TableComponent={CompanyTable}
      loading={loading}
      headerWithCreation={header}
      SearchInput={CompanySearchInput}
      DataGridActions={CompanyDataGridActions}
    />
    </WithDataGridApi>
  );
}

export const MemoCompanies = React.memo(
  composeHOCs(withProcessesData)(Companies)
);
